<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Invoice Management
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn @click="addSettings" outline large class="white--text">
              <v-icon left dark> add </v-icon>
              NEW INVOICE SETTINGS
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="settingsListHeader"
          :items="settingsListByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td>
              <b>{{ getFirmName(props.item.firm) }}</b>
            </td>
            <td>
              <b>{{ props.item["invoiceIdPrefix"] }}</b>
            </td>
            <td>
              <b>{{ props.item["roundOff"] ? "Yes" : "No" }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editSetting(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteSetting(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addSettingsDialog" max-width="1000px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Settings</span>
          <v-spacer />
          <v-btn icon dark @click.native="addSettingsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-select
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-if="!currentSettings['.key']"
                  v-model="currentSettings.firm"
                ></v-select>
                <v-text-field
                  dense
                  v-else
                  :value="getFirmName(currentSettings.firm)"
                  :disabled="true"
                  label="Select Firm"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select
                  dense
                  :items="[
                    {
                      text: 'Due',
                      value: 'Debit',
                    },
                    {
                      text: 'Full Paid',
                      value: 'Credit',
                    },
                  ]"
                  label="Default Transaction type"
                  v-model="currentSettings.transactionType"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.alert"
                  :label="`${
                    'Invoice Alert Notification : ' +
                    (currentSettings.alert ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  ref="name"
                  type="text"
                  autocomplete="new-password"
                  v-model="currentSettings.invoiceIdPrefix"
                  label="Invoice ID Prefix"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.invoiceIdByDate"
                  :label="`${
                    'Invoice ID Date Wise Counter : ' +
                    (currentSettings.invoiceIdByDate ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.invoiceResetFinYear"
                  :label="`${
                    'Invoice ID Reset for Finacial Year : ' +
                    (currentSettings.invoiceResetFinYear ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  disabled
                  v-model="currentSettings.verifiedInvoice"
                  :label="`${
                    'Verified Invoice : ' +
                    (currentSettings.verifiedInvoice ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.roundOff"
                  :label="`${
                    'Invoice Round off : ' +
                    (currentSettings.roundOff ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.autoCounter"
                  :label="`${
                    'Invoice ID Auto Counter: ' +
                    (currentSettings.autoCounter ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.ewayBill"
                  :label="`${
                    'E-Way Bill Invoice: ' +
                    (currentSettings.ewayBill ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentSettings.invoiceImage"
                  :label="`${
                    'Image Upload with Create Invoice: ' +
                    (currentSettings.invoiceImage ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-switch
                  v-model="currentSettings.hideNegetiveStockAlert"
                  :label="`${
                    'Hide Negetive Stock Alert: ' +
                    (currentSettings.hideNegetiveStockAlert ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.individualProdBrokerage"
                  :label="`${
                    'Individual Product Brokerage: ' +
                    (currentSettings.individualProdBrokerage ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.deleteWithPassword"
                  :label="`${
                    'Delete Invoice With Password: ' +
                    (currentSettings.deleteWithPassword ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="currentSettings.deleteWithPassword">
                <v-text-field
                  type="password"
                  autocomplete="new-password"
                  v-model="currentSettings.deleteInvoicePassword"
                  label="Delete Invoice Password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select
                  dense
                  :items="['simple','basic','detailed','trail','theme1']"
                  label="Select Print Formats (By default it shows all when not selected any)"
                  v-model="currentSettings.supportedPrintFormats"
                  multiple
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select
                  dense
                  :items="stockReportTypes"
                  label="Closing Stock"
                  v-model="currentSettings.stockReportView"
                  :item-text="'text'"
                  :item-value="'value'"
                  :return-object="false"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="currentSettings.receiptNumberFinReset"
                  :label="`${
                    'ReceiptId Reset for Finacial Year : ' +
                    (currentSettings.receiptNumberFinReset ? 'YES' : 'NO')
                  }`"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="saveSettings"
            flat
            v-if="!currentSettings['.key']"
            >Save</v-btn
          >
          <v-btn
            color="blue darken-1"
            @click="updateSettings"
            flat
            v-if="!!currentSettings['.key']"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import firebase from "firebase";
export default {
  data() {
    return {
      addSettingsDialog: false,
      currentSettings: {
        firm: null,
        invoiceIdPrefix: "",
        roundOff: false,
        verifiedInvoice: false,
        autoCounter: false,
        stockReportView: "APP",
        ewayBill: false,
        brand: null,
        invoiceIdByDate: false,
        deleteWithPassword : false,
        deleteInvoicePassword : null,
      },
      settingsListHeader: [
        // { text: "Print- ID", value: "Term - ID" },
        { text: "Firm", value: "Name" },
        { text: "invoiceId Prefix", value: "Description" },
        { text: "Invoice Round off", value: "Description" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "firmSettings",
      this.$root.$firebaseRefs.firmSettings
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "stockReportTypes"]),
    firmsByBrand() {
      let alreadyExistsSettingsFirm = this.settingsListByBrand;
      return this.firms
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            !_.find(alreadyExistsSettingsFirm, function (o) {
              return o["firm"] == item[".key"];
            })
          );
        })
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    settingsListByBrand() {
      return this.firmSettings.filter(
        (item) => item["brand"] === this.selectedBrand
      );
    },
  },
  methods: {
    saveSettings() {
      this.$root.$firebaseRefs.firmSettings.push(this.currentSettings);
      this.addSettingsDialog = false;
    },

    addSettings() {
      this.currentSettings = {
        firm: null,
        brand: this.selectedBrand,
        invoiceIdPrefix: "",
        roundOff: false,
        verifiedInvoice: false,
        autoCounter: false,
        stockReportView: "APP",
        ewayBill: false,
        invoiceIdByDate: false,
        deleteWithPassword : false,
        deleteInvoicePassword : null,
      };
      this.addSettingsDialog = true;
    },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter((item) => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    editSetting(term) {
      this.currentSettings = JSON.parse(JSON.stringify(term));
      this.addSettingsDialog = true;
    },
    deleteSetting(term) {
      if (window.confirm("Do you want to Delete " + term.name + "?")) {
        this.$root.$firebaseRefs.firmSettings.child(term[".key"]).remove();
      }
    },
    updateSettings() {
      let settingsToUpdate = JSON.parse(JSON.stringify(this.currentSettings));
      delete settingsToUpdate[".key"];
      this.$root.$firebaseRefs.firmSettings
        .child(this.currentSettings[".key"])
        .update(settingsToUpdate, () => {
          this.currentSettings = {
            firm: null,
            brand: this.selectedBrand,
            invoiceIdPrefix: "",
            roundOff: false,
            verifiedInvoice: false,
            stockReportView: "APP",
            autoCounter: false,
            ewayBill: false,
            invoiceIdByDate: false,
            deleteWithPassword : false,
            deleteInvoicePassword : null,
          };
          this.addSettingsDialog = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/FirmSettings/FirmSettings.vue